import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() { this.animateIn() }

  animateIn() {
    this.element.classList.add("opacity-0", "translate-x-4")
    requestAnimationFrame(() => {
      this.element.classList.add("transition", "duration-300", "ease-out")
      this.element.classList.remove("opacity-0", "translate-x-4")
    })
  }
}
